export const common = {
  ok: "OK!",
  cancel: "Cancel",
  back: "Back",
  logOut: "Log Out",
  locationSearchPlaceholder: "Enter location to center map",
  save: "Save",
  upload: "Upload",
  actions: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    preview: "Preview",
    send: "Send",
    add: "Add",
    addAndClose: "Add and close",
    addAndContinue: "Add and continue",
    update: "Update",
    next: "Next",
    back: "Back",
    create: "Create",
    leave: "Leave",
    new: "New",
    remove: "Remove",
    copy: "Copy",
    copied: "Copied!",
    download: "Download",
    move: "Move",
    undo: "Undo",
    redo: "Redo"
  },
  fullscreen: {
    enter: "Full screen",
    exit: "Exit full screen",
  },
  transcriptionInProgress: "Transcription in progress…",
  transcriptionsInProgress: "{{count}} transcriptions in progress",
  status: {
    saving: "Saving...",
    creating: "Creating...",
    updating: "Updating...",
    adding: "Adding...",
    moving: "Moving...",
    deleting: "Deleting..."
  },
  messages: {
    description: "Description",
    name: "Name",
    title: "Title"
  },
  errors: {
    tryAgain: "Please try again",
    generic: "An error occurred. Please try again."
  },
  success: {
    saved: "saved successfully",
    settingsSaved: "Settings saved successfully",
    settingsSavedToCloud: "Settings saved successfully to cloud storage!",
    configurationSaved: "Configuration saved successfully!",
    subscriberRemoved: "Subscriber removed successfully",
    subscriberUpdated: "Subscriber updated successfully",
    subscriberAdded: "Subscriber added successfully",
    subscribersExported: "Subscribers exported successfully",
    subscribersUpdated: "Subscribers updated successfully",
    subscribersRemoved: "Subscribers removed successfully",
    formLinkCopied: "Form link copied to clipboard!",
    settingsReset: "Settings reset to defaults",
    budgetTrackerSaved: "Budget tracker saved",
    budgetTrackerDeleted: "Budget tracker deleted",
    budgetTrackerExpenseAdded: "Expense added",
    budgetTrackerCsvImported: "CSV expenses imported",
    budgetTrackerProjectStreamsSynced:
      "Updated project name on {{count}} work stream(s).",
    workstreamTimelineCreated: "Project workstream timeline created",
    workstreamTimelineDeleted: "Project workstream timeline deleted",
    workstreamTimelineImported: "Timeline imported",
    workstreamTimelineShared: "Sharing updated",
    workstreamTimelineLinkCopied: "Link copied",
    workstreamTimelinePublicEnabled: "Public view link turned on",
    workstreamTimelinePublicDisabled: "Public view link turned off",
  },
  buttons: {
    saveSettings: "Save Settings",
    resetToDefaults: "Reset to Defaults",
    updatePartnership: "Update Partnership",
    createPartnership: "Create Partnership",
    saveConfiguration: "Save Configuration",
    saveBudget: "Save Budget",
    saveCurrentBudget: "Save Current Budget",
    saveTemplates: "Save Templates",
    updateNewsletter: "Update Newsletter",
    createNewsletter: "Create Newsletter",
    saveChanges: "Save Changes",
    saveEvaluationData: "Save Evaluation Data"
  },
  validation: {
    emailRequired: "Please enter your email address",
    emailInvalid: "Please enter a valid email address",
    questionRequired: "This question is required",
    selectTriadPosition: "Please select a position on the triad",
    selectAtLeastOne: "Please select at least one option",
    selectOption: "Please select an option",
    valueBetween: "Please enter a value between {{min}} and {{max}}",
    textTooLong: "Text cannot be longer than {{maxLength}} characters"
  },
  delete: {
    confirmTitle: "Confirm Deletion",
    confirmMessage: "Are you sure you want to delete this item? This action cannot be undone.",
    typeToConfirmLabel: "Type \"{{phrase}}\" to confirm",
    typeToConfirmMismatch: "The text entered does not match.",
    budgetInstance: {
      title: "Delete Budget Instance",
      message: "Are you sure you want to delete this budget instance? This action cannot be undone."
    },
    budgetTracker: {
      title: "Delete Budget Tracker",
      message: "Are you sure you want to delete this budget tracker? This action cannot be undone."
    },
    wander: {
      title: "Delete Wander",
      message: "Are you sure you want to delete this wander? This action cannot be undone."
    },
    adminMessage: {
      title: "Delete Admin Message",
      message: "Are you sure you want to delete this admin message? This action cannot be undone."
    },
    subscriber: {
      title: "Remove Subscriber",
      message: "Are you sure you want to remove this subscriber? This action cannot be undone."
    },
    subscribers: {
      title: "Remove Selected Subscribers",
      message: "Are you sure you want to remove {{count}} selected subscribers? This action cannot be undone."
    }
  },
  notifications: {
    sendNotification: "Send Notification",
    notificationTitle: "Notification Title",
    message: "Message",
    targetAudience: "Target Audience",
    allUsers: "All Users",
    superAdmins: "Super Admins",
    facilitators: "Facilitators",
    sentSuccessfully: "Notification sent successfully!",
    sentToUsers: "Sent to {{count}} users",
    failedCount: "{{count}} failed",
    skippedCount: "{{count}} skipped",
    fillAllFields: "Please fill in both title and message fields",
    sendFailed: "Failed to send notification"
  },
  dialogs: {
    unsavedChanges: {
      title: "Unsaved Changes",
      message: "You have unsaved changes. Are you sure you want to leave this page?"
    }
  },
  daysOfWeek: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday"
  }
}
